/**
 * The promo bar's dismissal key, shared by the server wrapper (components/AlertBanner.tsx, reads it as a COOKIE)
 * and the client bar (components/AlertBannerClient.tsx, writes it to localStorage AND the cookie). A plain module
 * on purpose: a constant exported from a 'use client' file reaches a server component as a client reference,
 * not as the string.
 * Bump the version suffix with the copy, so an old dismissal does not hide a new notice.
 */
// 2026-11-01: bumped with the trial + intro copy (owner approved re-showing it once to people who closed the old bar).
export const ALERT_BANNER_DISMISS_KEY = 'alertBannerDismissed_v2026_nov1_trial_intro'
